import React, { useState } from "react";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import { MuiDropDown } from "./../components/basicComponent/MuiDropDown";
import MuiButton from "./../components/basicComponent/MuiButton";
import MuiDatePicker from "./../components/basicComponent/MuiDatePicker";
import MuiSearchSelect from "./../components/basicComponent/MuiSearchSelect";
import Header from "./../sharedScreens/Header";

const InsurancePlanMapping = () => {
  const [active, setActive] = useState<Boolean>(false);
  const columns = [
    "All",
    "Supplier Name",
    "Plan",
    "Traveller Type",
    "Plan Name",
    "Plan Type",
    "Geographical Area",
    "Minimum Age",
    "Maximum Age",
    "Minimum Days",
    "Maximum Days",
  ];
  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            {/* <div className="card-header text-center">
              <h3 className="card-title">Insurance Plan Mapping</h3>
            </div> */}
            <div className="card-header mb-1 managebookingg">
              <h3 className="card-title titlecolorr">Insurance Plan Mapping</h3>
              <button onClick={() => setActive(!active)} className="fliter-btn">
                <span>{active ? "Create" : "View  "}</span>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    {active && (
                      <div className="row mt-4">
                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Branch"}
                            label="Branch "
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>

                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Agency Name "}
                            label="Agency Name  "
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>

                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Status"}
                            label="Status "
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "8px",
                          }}
                        >
                          <div className="user-button w-full">
                            <MuiButton className="clear-btn " label="Clear" />
                            <MuiButton
                              className="main-btn get-btn"
                              variant="contained"
                              size="large"
                              type="submit"
                              label={"Get"}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {!active && (
                      <div className="row mt-4">
                        <div className="d-flex gap-3 p-3">
                          <div className="border rounded shadow-sm w-50">
                            <div className="d-flex align-items-center bg-dark text-white p-2">
                              <input
                                type="checkbox"
                                checked
                                readOnly
                                className="form-check-input"
                              />
                              <span className="me-auto">All</span>
                              <strong>Supplier</strong>
                            </div>
                            <div className="p-2">
                              {/* Supplier items can be mapped here */}
                            </div>
                          </div>
                          <div
                            className="border rounded shadow-sm flex-grow-1 "
                            style={{ minWidth: "800px", overflowX: "auto" }}
                          >
                            {/* Header with horizontal scroll */}

                            <div
                              className="d-flex align-items-center bg-dark text-white p-2"
                              style={{ minWidth: "1498px" }}
                            >
                              {columns.map((col, index) => (
                                <div
                                  key={index}
                                  className="flex-shrink-0 text-nowrap me-3"
                                  style={{ minWidth: 120 }}
                                >
                                  {col === "All" ? (
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                    />
                                  ) : (
                                    col
                                  )}
                                </div>
                              ))}
                            </div>

                            {/* Body with horizontal and vertical scroll */}
                            <div style={{ height: "200px" }}>
                              <div
                                className="d-flex"
                                style={{ minWidth: "800px" }}
                              >
                                {/* Repeat rows or table content here */}
                                <div className="text-center text-muted w-100 p-3">
                                  No data available
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Branch"}
                            label="Branch "
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>

                        <div className="col-md-4 mt-3">
                          <MuiSearchSelect
                            placeholder={"Agency Name "}
                            label="Agency Name  "
                            options={[]}
                            onChange={function (
                              value: string,
                              id: string,
                              data: any
                            ): void {
                              throw new Error("Function not implemented.");
                            }}
                            value={""}
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "8px",
                          }}
                        >
                          <div className="user-button w-full">
                            <MuiButton className="clear-btn " label="Clear" />
                            <MuiButton
                              className="main-btn get-btn"
                              variant="contained"
                              size="large"
                              type="submit"
                              label={"Varient"}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default InsurancePlanMapping;
